import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ProductReleaseService } from '../../services/ProductReleaseService';
import { Subscription } from 'rxjs';
import { MdSnackBar, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { IChangeLog } from '../../interfaces/ChangeLog';
import { AdalService } from '../../shared/adal.service';
import { AppLoaderService } from '../../../services/app-loader/app-loader.service';
import { UserService } from '../../services/UserService';
import { ProductReleaseFileRead } from '../../interfaces/ProductReleaseFileReadEnum.model';

import { has } from 'core-js/core/dict';
import { ProductRevFileNotReadFromFile } from '../../interfaces/ProductRevFileNotReadFromFile.model';


@Component({
    selector: 'my-page-layout-add-edit-productrelease',
    styles: ['./addProductrelease.component.css'],
    template: require('./addproductrelease.component.html')
})
export class PageLayoutProductReleaseComponent {

    // For Develeoper Rights
    IsDeveloperRights: any;
    IsFileSize: boolean = false;
    IsPackageSize: boolean = false;
    IsChangeLog: boolean;
    EditFileHash: string;
    arrayBuffer: any;
    IsAllowedToAdd = false;

    EditHash: boolean = false;
    // Package File and DBVersion visible
    IsProductCodeVisble: boolean = false;
    ProductCodePanelVisble = [14, 89];

    // Release Status for Edit File Upload
    ProductReleaseStatus: number = 0;

    // Button Disable
    CancelButtonDisabled = false;
    SaveButtonDisabled = false;

    // for Change Log
    dynamicArray: Array<IChangeLog> = [];
    newDynamic: any = {};

    // For File Upload
    eventdata: any;
    uploadresponse: string;
    percentDone: number = 0;
    uploadSuccess: boolean;


    // For Package Upload
    packageuploadresponse: string;
    packagepercentDone: number = 0;
    packageuploadSuccess: boolean;
    packagedata: any;

    submitted = false;
    validationForm: FormGroup;

    // For Error Display
    errorMessage: string = "";

    private sub: Subscription;

    // For Display Purpose Edit
    filename: string = "";
    filesize: number;
    filehash: string = null;
    filepath: string;

    ProductReleaseId: number = 0;

    // For Package Support File
    ProductReleaseSupport: Array<any> = [];
    packagefiles: Array<any> = [];
    packagefilehash: Array<any> = [];
    ProductReleaseSupportEditData // For Display Purpose
    fileContent: string | ArrayBuffer;

    ProductReleaseNo: string;
    LastProductReleaseNo: string;
    Title: string;
    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private productReleaseService: ProductReleaseService,
        public snackBar: MdSnackBar,
        private appLoaderService: AppLoaderService,
        private adalService: AdalService,
        private userService: UserService,
        public dialogRef: MdDialogRef<PageLayoutProductReleaseComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) {

        // Check Authentication               
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }

        // On Edit Get Data
        
        if (this.data.ProductReleaseId != 0) {
            if (this.data.SubProductName != '')
                this.Title = "Edit " + this.data.ProductName + " [" + this.data.SubProductName + "] " + "Release";
            else
                this.Title = "Edit " + this.data.ProductName + " Release";

            this.ProductReleaseId = this.data.ProductReleaseId;
            this.getProductReleaseDetails(this.data.ProductReleaseId);
            this.getChangeLogDetails(this.data.ProductReleaseId);

        }
        else {
            if (this.data.SubProductName != '')
                this.Title = "Add " + this.data.ProductName + " [" + this.data.SubProductName + "] " + "Release";
            else
                this.Title = "Add " + this.data.ProductName + " Release";
        }
        this.getUserRights(Number(localStorage.getItem('userid')), this.data.ParentProductId);
    }

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {
        this.validationForm = this.formBuilder.group({
            ProductReleaseNo: ['', Validators.required],
            ReleaseDate: this.formBuilder.control(moment().format("YYYY-MM-DD"), Validators.required),
            DBVersion: [''],
            file: ['', Validators.required],
            packagefile: [''],
            ChangeLogs: this.ProductReleaseId == 0 ? this.formBuilder.array([this.createChangeLog(null)]) : this.formBuilder.array([]),
        });

        // For Specific Product Visible DBVersion and Package File Upload
        this.ProductCodePanelVisble.forEach(element => {
            if (element == this.data.ProductCode) {
                this.IsProductCodeVisble = true;
            }
        });

        if (this.IsProductCodeVisble) { // In SCAL DBVesion and Package File Required
            this.validationForm.get('DBVersion').setValidators(Validators.required);
            this.validationForm.get('DBVersion').updateValueAndValidity();
            this.validationForm.get('DBVersion').setValidators(Validators.pattern('^[0-9]*$'));
            this.validationForm.get('DBVersion').updateValueAndValidity();
            this.validationForm.get('packagefile').setValidators(Validators.required);
        }

        // G3,PMD 2 and G3GLT case File Revision No read from File
        if (this.data.ProductCode == ProductReleaseFileRead.G3 || this.data.ProductCode == ProductReleaseFileRead.PMD2 || this.data.ProductCode == ProductReleaseFileRead.G3GLT || this.data.ProductCode == ProductReleaseFileRead.PMD2GLT || this.data.ProductCode == ProductReleaseFileRead.TrakIT4) {
            const ctrl = this.validationForm.get('ProductReleaseNo');
            ctrl.disable();
        }
        this.validationForm.get('DBVersion').updateValueAndValidity();
        this.validationForm.get('packagefile').updateValueAndValidity();

        // In Edit Mode ProductReleaseNo Disable and Product File and Package File Required Field Validator Remove
        if (this.ProductReleaseId != 0) {
            const ProductReleaseNo = this.validationForm.get('ProductReleaseNo');            
            if ((this.data.ProductCode == ProductRevFileNotReadFromFile.SCAL360 || this.data.ProductCode == ProductRevFileNotReadFromFile.SmartCal360 || this.data.ProductCode == ProductRevFileNotReadFromFile.LZ50) && (this.data.Status==0))
                ProductReleaseNo.enable();
            else
                ProductReleaseNo.disable();

            this.validationForm.get("file").clearValidators();
            this.validationForm.get("file").setErrors(null);
            this.validationForm.get('file').updateValueAndValidity();
            this.validationForm.get('packagefile').clearValidators();
            this.validationForm.get('packagefile').updateValueAndValidity();
        }
    }
    DBVersionNumericOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    //#region "GetUserRightsByUserIdandProductId"
    getUserRights(UserId, ProductId) {
        this.userService.getUserRightsById(UserId, ProductId).subscribe(
            Data => {

                this.IsDeveloperRights = Data[0].IsAdd;   // If IsDeveloperRights==true then Update Product File and Package Files              
            });
    }
    //#endregion

    //#region "GetProductReleaseDetailsByProductReleaseId"
    getProductReleaseDetails(ProductReleaseId: number) {
        this.appLoaderService.open();
        this.productReleaseService.getProductReleaseById(ProductReleaseId).subscribe(
            releaseData => {
                if (!releaseData.IsError && releaseData.DataObject != null) {
                    this.validationForm.patchValue({
                        ProductReleaseNo: releaseData.DataObject.ProductReleaseNo,
                        ReleaseDate: moment(releaseData.DataObject.ReleaseDate).format("YYYY-MM-DD"),
                        DBVersion: releaseData.DataObject.DBVersion
                    });                    
                    this.LastProductReleaseNo = releaseData.DataObject.ProductReleaseNo;
                    this.EditFileHash = releaseData.DataObject.HashKey;
                    this.filename = releaseData.DataObject.FileName;
                    this.filehash = releaseData.DataObject.HashKey;
                    this.filesize = releaseData.DataObject.FileSize;
                    this.filepath = releaseData.DataObject.FilePath;

                    if (releaseData.DataObject.ProductReleaseSupport == "" && this.IsProductCodeVisble && releaseData.DataObject.Status == 0) {
                        this.validationForm.get('packagefile').setValidators([Validators.required]);
                        this.validationForm.get('packagefile').updateValueAndValidity();
                    }
                    this.ProductReleaseSupportEditData = releaseData.DataObject.ProductReleaseSupport;
                    this.ProductReleaseStatus = releaseData.DataObject.Status;
                    this.appLoaderService.close();
                }
                else {
                    this.errorMessage = releaseData.Error;
                    this.appLoaderService.close();
                }
            },
            _error => {
                this.appLoaderService.close();
            });
    }
    //#endregion

    //#region "getChangeLogDetailsbyProductReleaseId"
    getChangeLogDetails(ProductReleaseId: number) {
        this.productReleaseService.getChangeLogDetails(ProductReleaseId).subscribe(
            data => {
                if (data.DataObject.length > 0) {
                    let changelog = this.validationForm.get('ChangeLogs') as FormArray;
                    for (let row of data.DataObject) {
                        changelog.push(this.createChangeLog(row));
                    }
                }
            });
    }
    //#endregion

    checkRevsionNo() {
        if (this.validationForm.value.ProductReleaseNo != "") {
            let CheckRevModel = {
                ProductReleaseId: Number(this.ProductReleaseId),
                ProductRev: this.validationForm.value.ProductReleaseNo,
                ProductId: Number(this.data.ProductId)
            }
            this.productReleaseService.checkRevisionNo(CheckRevModel).subscribe(
                SoftwareData => {
                    if (SoftwareData.DataObject.length > 0) {
                        this.validationForm.patchValue({
                            ProductReleaseNo: ''
                        });
                        this.SaveButtonDisabled = false;
                        this.CancelButtonDisabled = false;
                        this.appLoaderService.close();
                        this.errorMessage = "Revision Already Exists..!";
                    }
                    else {
                        this.errorMessage = ""
                    }
                },
                (_error: any) => this.CancelButtonDisabled = false);
        }
        else {
            this.errorMessage = ""
        }
    }

    checkDBVersion() {
        if (this.validationForm.value.DBVersion != "") {
            this.productReleaseService.checkDBVersion(this.validationForm.value.DBVersion, Number(this.data.ProductId), Number(this.ProductReleaseId)).subscribe(
                Data => {
                    if (!Data.IsError) {
                        this.errorMessage = ""
                    }
                    else {
                        this.validationForm.patchValue({
                            DBVersion: ''
                        });
                        this.SaveButtonDisabled = false;
                        this.CancelButtonDisabled = false;
                        this.appLoaderService.close();
                        this.errorMessage = Data.Error;
                    }
                },
                (_error) => this.CancelButtonDisabled = false);
        }
        else {
            this.errorMessage = ""
        }
    }

    private createChangeLog(data: any): FormGroup {
        data = data || { ChangeLog: null, ProductReleaseChangeLogId: 0, ProductReleaseId: 0 }
        return this.formBuilder.group({
            ProductReleaseChangeLogId: [0],
            ChangeLog: [data.ChangeLog, Validators.required],
            ProductReleaseId: [0]
        });
    }

    get ChangeLogs(): FormArray {
        return this.validationForm.get("ChangeLogs") as FormArray;
    }

    addChangeLog() {
        const changelog = this.validationForm.get('ChangeLogs') as FormArray;
        changelog.push(this.createChangeLog(null));
        this.IsChangeLog = false;
        if (changelog.length == 0) {
            this.IsChangeLog = true;
        }
    }

    deleteChangeLog(index) {
        const changelog = this.validationForm.get('ChangeLogs') as FormArray
        if (changelog.length == 1) {
            this.IsChangeLog = true;
        }
        else {
            this.validationForm.controls['ChangeLogs'].markAsDirty();
            this.ChangeLogs.removeAt(index);
        }
    }

    //#region "Read File Bytes and Convert HexaDecimal to Decimal"
    hexadecimalToDecimal(hexVal) {
        let len = hexVal.length;

        // Initializing base value to 1, i.e 16^0
        let base = 1;

        let dec_val = 0;

        // Extracting characters as digits from last
        // character
        for (let i = len - 1; i >= 0; i--) {
            // if character lies in '0'-'9', converting
            // it to integral 0-9 by subtracting 48 from
            // ASCII value
            if (hexVal.charAt(i) >= '0'
                && hexVal.charAt(i) <= '9') {
                dec_val += (hexVal.charAt(i).charCodeAt(0) - 48) * base;

                // incrementing base by power
                base = base * 16;
            }

            // if character lies in 'A'-'F' , converting
            // it to integral 10 - 15 by subtracting 55
            // from ASCII value
            else if (hexVal.charAt(i) >= 'A'
                && hexVal.charAt(i) <= 'F') {
                dec_val += (hexVal.charAt(i).charCodeAt(0) - 55) * base;

                // incrementing base by power
                base = base * 16;
            }
        }

        // Code to Resolved G3 Bug [Remove this code when SCAL new relase with G3 Changes]
        let decimal_value;

        if (dec_val.toString().length < 2)
            decimal_value = "0" + dec_val;
        else
            decimal_value = dec_val;
        return decimal_value;
    }
    //#endregion

    CheckChangeLog(value) { // to Enable disbale At least one check box required        
        if (value != "") {
            this.IsChangeLog = false;
        }
    }

    getAllowedToAdd(ProductId) {
        this.SaveButtonDisabled = true;
        this.CancelButtonDisabled = true;

        if (this.validationForm.get("ProductReleaseNo").value != null || this.validationForm.get("ProductReleaseNo").value != undefined)
            this.ProductReleaseNo = this.validationForm.get("ProductReleaseNo").value;
        else
            this.ProductReleaseNo = this.data.payload.ProductReleaseNo;


        this.productReleaseService.getIsAllowedToAddReleaseByProductId(ProductId).subscribe(
            data => {
                if (this.ProductReleaseId != 0) {
                    this.IsAllowedToAdd = false;
                }
                else {

                    if (!data.IsError && data.DataObject != null) {
                        this.IsAllowedToAdd = false;
                    }
                    else {
                        this.IsAllowedToAdd = true;
                        this.SaveButtonDisabled = false;
                        this.CancelButtonDisabled = false;
                        this.errorMessage = "You can't add new release because there is already one pending release in queue";
                        return
                    }
                }
                if (!this.IsAllowedToAdd && this.ProductReleaseNo != "") {
                    this.CheckRevNoandDBVersion();
                }
            },
            _error => {
                this.CancelButtonDisabled = false;
            });
    }

    CheckRevNoandDBVersion() {
        let CheckRevModel = {
            ProductReleaseId: Number(this.ProductReleaseId),
            ProductRev: this.ProductReleaseNo,
            ProductId: Number(this.data.ProductId)
        }
        this.productReleaseService.checkRevisionNo(CheckRevModel).subscribe(
            SoftwareData => {
                if (SoftwareData.DataObject.length > 0) {
                    if (this.data.ProductCode != ProductReleaseFileRead.G3 && this.data.ProductCode != ProductReleaseFileRead.PMD2 && this.data.ProductCode != ProductReleaseFileRead.G3GLT && this.data.ProductCode != ProductReleaseFileRead.PMD2GLT && this.data.ProductCode != ProductReleaseFileRead.TrakIT4) {
                        this.validationForm.patchValue({
                            ProductReleaseNo: ''
                        });
                    }
                    this.SaveButtonDisabled = false;
                    this.CancelButtonDisabled = false;
                    this.errorMessage = "Revision Already Exists..!"
                    this.appLoaderService.close();
                }
                else {
                    this.CheckDBVersionandUpload();
                }
            },
            (_error: any) => this.CancelButtonDisabled = false);
    }


    CheckDBVersionandUpload() {
        // Check DB Version [If DBVersion is there]
        if (this.IsProductCodeVisble) {
            if (this.validationForm.value.DBVersion != "") {
                this.productReleaseService.checkDBVersion(this.validationForm.value.DBVersion, Number(this.data.ProductId), Number(this.ProductReleaseId)).subscribe(
                    Data => {
                        if (Data.IsError) {
                            this.appLoaderService.close();
                            this.validationForm.patchValue({
                                DBVersion: ''
                            });
                            this.SaveButtonDisabled = false;
                            this.CancelButtonDisabled = false;
                            this.errorMessage = Data.Error;
                            return;
                        }
                        this.CalculateProductHashandUpload();
                    },
                    (_error: any) => this.CancelButtonDisabled = false);
            }
        }
        else {
            this.errorMessage = "";
            this.CalculateProductHashandUpload();
        }
    }


    // On Submit Click Event
    onSubmit(): void {
        this.errorMessage = "";
        this.IsChangeLog = false;


        if (this.validationForm.invalid) {
            return;
        }

        // First Check Any Pending Release in Queue
        this.getAllowedToAdd(this.data.ProductId);
    }

    oneditcancel(): void {
        this.dialogRef.close(null);
    }

    CalculateProductHashandUpload(): void {
        if (!this.IsFileSize && !this.IsPackageSize) {
            this.appLoaderService.open();

            if (this.eventdata != null && this.eventdata.target.files.length > 0) {
                this.getHash(this.eventdata.target.files[0]);
            }
            else if (this.packagedata != null && this.packagedata.target.files.length > 0) {
                this.getPackageHash(this.packagedata.target.files[0]);
            }
            else {
                this.SaveProductDetail();
            }
        }
    }

    detectMimeType(file: File) {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (reader.result instanceof ArrayBuffer) {
                    const arr = new Uint8Array(reader.result).subarray(0, 4);
                    let header = "";
                    for (let i = 0; i < arr.length; i++) {
                        header += arr[i].toString(16);
                    }

                    // Common file signatures (Magic Numbers)
                    const mimeTypes: { [key: string]: string } = {
                        "89504e47": "image/png",
                        "47494638": "image/gif",
                        "25504446": "application/pdf",
                        "504b0304": "application/zip",
                        "d0cf11e0": "application/x-msi",
                        "ffd8ffe0": "image/jpeg",
                        "ffd8ffe1": "image/jpeg",
                        "ffd8ffe2": "image/jpeg",
                        "4d5a9000": "application/x-msdownload"
                    };

                    resolve(mimeTypes[header] || "unknown");
                } else {
                    reject("Failed to read file.");
                }
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file.slice(0, 4)); // Read first 4 bytes
        });
    }

    //#region "Get Product File OnChange Event"
    onChange(event) {
        this.errorMessage = "";
        this.uploadresponse = "";
        this.eventdata = event;
        let fileList: FileList = this.eventdata.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];            
            if (this.data.ProductCode == ProductRevFileNotReadFromFile.SCAL360) {
                this.detectMimeType(file).then((mime) => {
                    if(mime!='application/x-msi'){
                        this.uploadSuccess = false;
                        this.uploadresponse = "Please Select MSI file.";
                        this.IsFileSize = true;
                        this.SaveButtonDisabled = true;
                        return false;
                    }
                });             
            }
            this.errorMessage = "";
            let sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

            if (Number(sizeInMB) > 1000) {
                this.uploadSuccess = false;
                this.uploadresponse = "Product File Size should not be greater than 1 GB";
                this.IsFileSize = true;
                this.SaveButtonDisabled = true;
                return false;
            }
            this.IsFileSize = false;

            // In G3 and PMD2 Case get ProductReleaseNo and ProductId   
            this.ReadSelectedProductFile(sizeInMB, this.eventdata)

            if (this.IsProductCodeVisble && this.ProductReleaseId == 0 && this.IsPackageSize)
                this.SaveButtonDisabled = true;
            else
                this.SaveButtonDisabled = false;

        }
        else {
            if (this.data.ProductCode == 12 && this.ProductReleaseId == 0) {
                this.validationForm.patchValue({ ProductReleaseNo: '' });
            }
            else if (this.data.ProductCode == 12 && this.ProductReleaseId != 0) {
                this.validationForm.patchValue({ ProductReleaseNo: this.LastProductReleaseNo });
            }
            this.SaveButtonDisabled = false;
        }
    }
    //#endregion

    //#region "Read G3,PMD2,G3GLT"
    ReadSelectedProductFile(sizeInMB, event) {
        // In G3 and PMD2 Case get ProductReleaseNo and ProductId   
        if (this.data.ProductCode == ProductReleaseFileRead.G3 || this.data.ProductCode == ProductReleaseFileRead.PMD2 || this.data.ProductCode == ProductReleaseFileRead.G3GLT || this.data.ProductCode == ProductReleaseFileRead.PMD2GLT || this.data.ProductCode == ProductReleaseFileRead.TrakIT4) {
            if (Number(sizeInMB) > 5) {
                this.uploadSuccess = false;
                this.uploadresponse = "File Size should not be greater than 5 MB";
                this.IsFileSize = true;
                this.SaveButtonDisabled = true;
                return false;
            }

            const reader = new FileReader();
            reader.onload = () => {
                this.arrayBuffer = reader.result;
                let ProductCode = (Array.prototype.map.call(new Uint8Array(this.arrayBuffer.slice(0x00000000, 0x00000001)), x => ('00' + this.hexadecimalToDecimal(x.toString(16).toUpperCase())).slice(-2)).join(''));
                let ProductSubCode = (Array.prototype.map.call(new Uint8Array(this.arrayBuffer.slice(0x00000001, 0x00000002)), x => ('00' + this.hexadecimalToDecimal(x.toString(16).toUpperCase())).slice(-1)).join(''));
                let ProductReleaseNo = (Array.prototype.map.call(new Uint8Array(this.arrayBuffer.slice(0x00000003, 0x00000006)), x => (this.hexadecimalToDecimal(x.toString(16).toUpperCase()))).join('.'));
                if ((this.data.ProductCode == ProductReleaseFileRead.G3 && ProductCode != this.data.ProductCode) || (this.data.ProductCode == ProductReleaseFileRead.TrakIT4 && ProductCode != this.data.ProductCode)) {// G3 Case Product Code Shoud be match
                    this.uploadSuccess = false;
                    this.uploadresponse = "Selected file is not appropriate for " + this.data.ProductName + " Firmware";
                    this.SaveButtonDisabled = true;
                    return;
                }
                else if (this.data.ProductCode == ProductReleaseFileRead.PMD2 || this.data.ProductCode == ProductReleaseFileRead.G3GLT || this.data.ProductCode == ProductReleaseFileRead.PMD2GLT) { // IN PMD2 & G3GLT Code and  Sub Type should be match                             
                    if ((ProductCode != this.data.ProductCode) || (ProductSubCode != this.data.SubType)) {
                        this.uploadSuccess = false;
                        this.uploadresponse = "Selected file is not a valid for " + this.data.ProductName + " " + this.data.SubProductName + " Firmware";
                        this.SaveButtonDisabled = true;
                        return;
                    }
                }
                this.validationForm.get("ProductReleaseNo").setValue(ProductReleaseNo);
            };
            reader.readAsArrayBuffer(event.target.files[0]);
        }
    }
    //#endregion


    //#region "Get Product File Hash"
    getHash(filename) {
        let hashdata = CryptoJS.algo.SHA256.create();
        let file = filename;
        if (file) {
            let reader = new FileReader();
            let size = file.size;
            let chunk_size = Math.pow(2, 22);
            let offset = 0;
            let bytes = 0;
            reader.onloadend = (_e) => {
                if (reader.readyState == FileReader.DONE) {
                    this.uploadSuccess = true;
                    this.uploadresponse = "Computing File Hash...!";
                    //every chunk read updating hash
                    hashdata.update(this.arrayBufferToWordArray(reader.result));
                    let chunk: any = reader.result;
                    bytes += chunk.length;
                    if ((offset < size)) {
                        offset += chunk_size;
                        let blobchunk = file.slice(offset, offset + chunk_size);
                        reader.readAsArrayBuffer(blobchunk);
                    } else {
                        let hash = hashdata.finalize().toString();
                        this.CheckAndUploadProductFile(hash);
                    }
                }
            };
            let blob = file.slice(offset, offset + chunk_size);
            reader.readAsArrayBuffer(blob);
        }
    }
    //#endregion

    //#region "Product File Upload"
    CheckAndUploadProductFile(hash) {
        if (this.ProductReleaseId != 0) {
            if (String(hash) == String(this.EditFileHash)) {
                this.uploadSuccess = false;
                this.appLoaderService.close();
                this.uploadresponse = "Same Product File is not uploaded again...!"
                this.SaveButtonDisabled = true;
                this.CancelButtonDisabled = false;
                return;
            }

            this.filehash = String(hash);
            if (this.packagedata != null && this.packagedata.target.files.length > 0) {
                this.uploadresponse = '';
                this.EditHash = true;
                this.getPackageHash(this.packagedata.target.files[0])
            }
            else {
                this.uploadfiles(this.eventdata.target.files[0]);
            }
        }
        else {
            this.filehash = String(hash);
            this.uploadfiles(this.eventdata.target.files[0]);
        }
    }
    //#endregion

    //#region "arrayBufferToWordArray [Used in Hash Function"]
    arrayBufferToWordArray(fileResult) {
        let i8a = new Uint8Array(fileResult);
        return CryptoJS.lib.WordArray.create(i8a, i8a.length);
    }
    //#endregion

    //#region "Upload Product File and Package Files"
    uploadfiles(filelist) {

        let file: File = filelist;
        let formData: FormData = new FormData();
        this.filename = file.name.toString();
        let size = 0
        if (file.size.toString() == null)
            size = Number(0);
        else
            size = Number(file.size.toString());

        this.filesize = Number(size);
        formData.append("ProductName", this.data.ProductName);
        formData.append("SubProductName", this.data.SubProductName);
        formData.append("ProductReleaseNo", this.ProductReleaseNo);
        formData.append("File", file);
        formData.append("fileName", this.filename);
        formData.append("FileHash", this.filehash);
        this.productReleaseService.UploadFiles(formData)
            .subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    this.uploadresponse = '';
                    this.percentDone = Math.round((100 * event.loaded) / event.total);
                    if (this.percentDone == 100) {
                        this.uploadSuccess = true;
                        this.uploadresponse = "File is uploading on azure...!";
                    }
                } else if (event instanceof HttpResponse) {
                    if (event.body.DataObject != null) {
                        this.uploadSuccess = true;
                        this.uploadresponse = "Successfully Upload";
                        this.filepath = event.body.DataObject;
                        // If Package File Exists then Upload Package File Otherwise Save Funciton Call
                        this.CheckPackageFileandHash();
                    }
                    else {
                        this.uploadSuccess = false;
                        this.CancelButtonDisabled = false;
                        this.uploadresponse = event.body.Error;
                        this.appLoaderService.close();
                    }
                }
            },
                _error => {
                    this.uploadSuccess = false;
                    this.uploadresponse = "Product file upload failure. Please contact administrator..!";
                    this.CancelButtonDisabled = false;
                    this.appLoaderService.close();
                }
            )
    }
    //#endregion

    //#region "If Any Package File is there then First Get Package Hash"     
    CheckPackageFileandHash() {
        if (this.packagedata != null && this.packagedata.target.files.length > 0) {
            let PackageFileList = this.packagedata.target.files[0];
            this.EditHash = false;
            this.getPackageHash(PackageFileList);
        }
        else {
            this.SaveProductDetail();
        }
    }
    //#endregion

    //Package File Upload
    packageFileUpload() {

        let formData: FormData = new FormData();
        let fileList: FileList = this.packagedata.target.files;

        let filename = fileList[0].name.toString();
        let size = 0;
        size = Number(fileList[0].size.toString());

        formData.append("ProductName", this.data.ProductName);
        formData.append("ProductReleaseNo", this.ProductReleaseNo);
        formData.append("File", fileList.item(0));
        formData.append("fileName", filename);
        formData.append("PackageFileHash", this.packagefilehash[0]);

        let PackageModel = {
            PackageFileHashKey: this.packagefilehash[0],
            PackageFileName: fileList[0].name.toString(),
            PackageFilePath: this.data.ProductName + "\\" + this.ProductReleaseNo + "\\SupportFile\\" + fileList[0].name.toString(),
            PackageFileSize: Number(size)
        }
        this.ProductReleaseSupport.push(PackageModel);

        this.productReleaseService.PackageUploadFiles(formData)
            .subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    this.packageuploadresponse = '';
                    this.packagepercentDone = Math.round((100 * event.loaded) / event.total);
                    if (this.packagepercentDone == 100) {
                        this.packageuploadSuccess = true;
                        this.packageuploadresponse = "File is uploading on azure...!";
                    }
                }
                else if (event instanceof HttpResponse) {
                    if (event.body.DataObject != null) {
                        this.packagepercentDone = 0;
                        this.packageuploadSuccess = true;
                        this.packageuploadresponse = "Successfully Upload";
                        this.SaveProductDetail();
                    }
                    else {
                        this.packageuploadSuccess = false;
                        this.CancelButtonDisabled = false;
                        this.packageuploadresponse = event.body.Error;
                        this.appLoaderService.close();
                    }
                }
            },
                _error => {
                    this.packageuploadSuccess = false;
                    this.packageuploadresponse = "Package file upload failure.Please contact administrator...!";
                    this.CancelButtonDisabled = false;
                    this.appLoaderService.close();
                }
            )

    }

    //#region "Save & Update Package Release"
    SaveProductDetail() {
        if (this.ProductReleaseId == 0 || this.ProductReleaseId == undefined) {
            let model = {
                ProductReleaseId: 0,
                ProductId: Number(this.data.ProductId),
                ProductReleaseNo: this.ProductReleaseNo,
                ReleaseDate: this.validationForm.value.ReleaseDate,
                FilePath: this.filepath,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid')),
                FileName: this.filename,
                FileSize: this.filesize,
                HashKey: String(this.filehash),
                ChangeLog: this.validationForm.value.ChangeLogs,
                DBVersion: this.IsProductCodeVisble ? String(this.validationForm.value.DBVersion) : "",
                ProductReleaseSupport: this.ProductReleaseSupport,

            };

            this.productReleaseService.addProductReleaseMenually(model).subscribe(
                (data) => {
                    if (data.IsError) { // If Any Error
                        this.errorMessage = "Product Release is not added. Please contact Administrator..!";
                        this.appLoaderService.close();
                        this.CancelButtonDisabled = false;
                        return;
                    }

                    // Save Release
                    this.validationForm.patchValue({
                        ProductReleaseNo: '',
                        Title: ''
                    });
                    this.snackBar.open("Product has been Saved Successfully", "", {
                        duration: 2000,
                    });
                    this.appLoaderService.close();
                    this.dialogRef.close(model);
                },
                (_error: any) => {
                    this.appLoaderService.close();
                    this.CancelButtonDisabled = false;
                });
        }
        else {

            let model = {
                ProductReleaseId: this.ProductReleaseId,
                ProductId: Number(this.data.ProductId),
                ProductReleaseNo: this.ProductReleaseNo,
                ReleaseDate: this.validationForm.value.ReleaseDate,
                FilePath: this.filepath,
                UpdatedBy: Number(localStorage.getItem('userid')),
                FileName: this.filename,
                FileSize: this.filesize,
                HashKey: String(this.filehash),
                ChangeLog: this.validationForm.value.ChangeLogs,
                DBVersion: this.IsProductCodeVisble ? String(this.validationForm.value.DBVersion) : "",
                ProductReleaseSupport: this.ProductReleaseSupport,

            };
            this.productReleaseService.updateProductReleaseDetail(model).subscribe(
                (data) => {
                    if (data.IsError) { // If Any Error
                        this.errorMessage = "Product Release is not updated. Please contact Administrator..!";
                        this.appLoaderService.close();
                        this.CancelButtonDisabled = false;
                        return;
                    }
                    // Update Release
                    this.validationForm.patchValue({
                        ProductReleaseNo: '',
                        Title: ''
                    });

                    this.dialogRef.close(null);
                    this.appLoaderService.close();
                    this.snackBar.open("Product has been Updated Successfully", "", {
                        duration: 2000,
                    });
                },
                (_error: any) => {
                    this.appLoaderService.close();
                    this.CancelButtonDisabled = false;
                });
        }
    }
    //#endregion

    //#region "IN STP Start,QA and Prod Release Release Status User Can not chnage the file"   
    disableInputClick = (event) => {
        if ((this.IsDeveloperRights && this.ProductReleaseStatus != 0) || (!this.IsDeveloperRights)) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    }
    //#endregion

    //#region "Replace Package File Event"
    UpdatePackageFile() {
        document.getElementById("packagefiles").click();
    }
    //#endregion

    //#region "Package File Change Event [Current Use in SCAL 360 Product]"    
    onPackageChange(event) {
        this.packagedata = event;
        this.packageuploadresponse = "";
        if (this.packagedata.target.files.length > 0) {
            let PackageFileList = this.packagedata.target.files;
            let file: File = PackageFileList[0];
            if (this.data.ProductCode == ProductRevFileNotReadFromFile.SCAL360) {
                if (file.type != 'application/x-zip-compressed') {
                    this.packageuploadSuccess = false;
                    this.packageuploadresponse = "Please Select ZIP file";
                    this.SaveButtonDisabled = true;
                    return false;
                }
            }
            let sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
            if (Number(sizeInMB) > 1000) {
                this.packageuploadSuccess = false;
                this.packageuploadresponse = "Package File Size should not be greater than 1 GB";
                this.IsPackageSize = true;
                this.SaveButtonDisabled = true;
                return false;
            }
            else {
                this.IsPackageSize = false;
                if (this.IsFileSize) {
                    this.SaveButtonDisabled = true;
                }
                else
                    this.SaveButtonDisabled = false;
            }
        }
        else
            this.SaveButtonDisabled = false;

    }
    //#endregion

    //#region "Get Package File Hash"
    public getPackageHash(filename) {
        let hashdata = CryptoJS.algo.SHA256.create();
        let file = filename;
        if (file) {
            let reader = new FileReader();
            let size = file.size;
            let chunk_size = Math.pow(2, 22);
            let offset = 0;
            let bytes = 0;
            reader.onloadend = (_e) => {
                if (reader.readyState == FileReader.DONE) {
                    this.packageuploadSuccess = true;
                    if (!this.EditHash) {
                        this.packageuploadresponse = "Computing File Hash...!";
                    }
                    hashdata.update(this.arrayBufferToWordArray(reader.result));
                    let chunk: any = reader.result;
                    bytes += chunk.length;

                    if ((offset < size)) {
                        offset += chunk_size;
                        let blobchunk = file.slice(offset, offset + chunk_size);
                        reader.readAsArrayBuffer(blobchunk);
                    } else {
                        let hash = hashdata.finalize().toString();
                        this.ComparePackageHashandUpload(hash);
                    }
                }
            };
            let blob = file.slice(offset, offset + chunk_size);
            reader.readAsArrayBuffer(blob);
        }
    }
    //#endregion

    //#region "getPackageHashandUploadPackageFile"
    ComparePackageHashandUpload(hash) {
        if (this.ProductReleaseId != 0 && this.ProductReleaseSupportEditData[0] != undefined) {
            if (hash == this.ProductReleaseSupportEditData[0].PackageFileHashKey) {
                this.packageuploadSuccess = false;
                this.appLoaderService.close();
                this.packageuploadresponse = "Same Package File is not uploaded again...!"
                this.SaveButtonDisabled = true;
                this.CancelButtonDisabled = false;
                return;
            }
            if (this.EditHash) {
                this.packagefilehash.push(hash);
                this.uploadfiles(this.eventdata.target.files[0]);
            }
            else {
                this.packagefilehash.push(hash);
                this.packageFileUpload();
            }
        }
        else {
            this.packagefilehash.push(hash);
            this.packageFileUpload();
        }
    }
    //#endregion
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/add-edit-productrelease/addproductrelease.component.ts